import { render, staticRenderFns } from "./ConsultationsAndReworksIndex.vue?vue&type=template&id=7f4d76b3"
import script from "./ConsultationsAndReworksIndex.vue?vue&type=script&lang=js"
export * from "./ConsultationsAndReworksIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports